module.exports = __webpack_public_path__ + "static/media/strongly_agree.9e0e2437.png";